@if ({ value: delivery$ | async }; as deliveryObj) {
  <div class="layout-col full">
    <div class="layout-row gap-sm">
      <mat-form-field class="flex" [floatLabel]="'always'">
        <mat-label>{{ 'deliveries.delivery' | translate }}</mat-label>
        <input
          matInput
          type="text"
          name="deliveryId"
          [value]="deliveryObj.value?.id"
          readonly
          placeholder="{{ 'deliveries.delivery' | translate }}"
        />
      </mat-form-field>
    </div>
    <div class="layout-row gap-sm">
      <mat-form-field floatLabel="always">
        <mat-label>{{ 'context.targetWeight' | translate }}</mat-label>
        <elder-quantity-input class="flex" readonly [ngModel]="deliveryObj.value?.targetWeight">
        </elder-quantity-input>
      </mat-form-field>
      <mat-form-field class="flex" floatLabel="always">
        <mat-label>{{ 'context.priority' | translate }}</mat-label>
        <input
          matInput
          type="text"
          name="priority"
          [value]="deliveryObj.value?.priority"
          readonly
        />
      </mat-form-field>
    </div>
  </div>
}
